import { render, staticRenderFns } from "./DocumentsTooltip.vue?vue&type=template&id=71341b82&scoped=true"
import script from "./DocumentsTooltip.vue?vue&type=script&lang=js"
export * from "./DocumentsTooltip.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTooltip.vue?vue&type=style&index=0&id=71341b82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71341b82",
  null
  
)

export default component.exports